<script>
  import { createEventDispatcher } from 'svelte';
  import { PreviewStatus } from '../utils/enum';

  const dispatch = createEventDispatcher();
  export let currentPreviewStatus;
</script>

<button
  type="button"
  on:click={() => dispatch('click')}
  class="w-16 h-16 rounded-full bg-white flex items-center justify-center"
>
  <div class="w-14 h-14 rounded-full bg-site-blue-2 border-2 border-black flex items-center justify-center">
    {#if currentPreviewStatus === PreviewStatus.PAUSE}
      <i class="icon-play_fill text-white w-6 h-6 flex items-center justify-center"></i>
    {:else}
      <i class="icon-pause text-white w-6 h-6 flex items-center justify-center"></i>
    {/if}
  </div>
</button>
